module.exports = __webpack_public_path__ + "img/cancel-card.584a14a1.svg";